import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl } from '@angular/forms';
import { Router, NavigationExtras } from '@angular/router';
import { ControllerForViewBase } from '../framework/controller-for-view-base';
import { PageContainerService, ClientAssetDataService } from '../../services';
import {
  ProjectDto,
  GetProjectsByUserCommandRequest,
  GetProjectsByUserCommandResponse,
  ClientDto, AssetDto,
  UserRoleDto
} from "../../data/CommandServiceDtos.generated";


@Component({
  selector: 'landing-page',
  templateUrl: './landing-page.component.html',
  styleUrls: ['./landing-page.component.scss']
})
export class LandingPageComponent extends ControllerForViewBase implements OnInit {
  clientList: ClientDto[];
  assetList: AssetDto[];
  cachedAssets: AssetDto[];
  projects: ProjectDto[];
  cachedProjects: ProjectDto[];
  clientCount: number = 0;
  assetControl = new FormControl();
  clientControl = new FormControl();
  projectSortControl = new FormControl();
  activeProjectsSelected: string = "active";
  projectTypes: boolean[] = [true, false, null];
  userRoles: UserRoleDto[];

  constructor(public pcs: PageContainerService, public clientOptionsState: ClientAssetDataService) {
    super(pcs);
  }

  ngOnInit() {
    this.loadData();
    this.assetControl.setValue(0);
    this.clientControl.setValue(0);
    this.projectSortControl.setValue("latest-desc");
  }

  ngAfterViewInit() {
    console.log("After View Init called");
    //this.loadState();
  }

  onlyTwoItems() {
    if (this.projects.length === 2)
      return true;

    return false;

  }

  get isAdmin(): Boolean {
    return this.pcs.clientSessionService.isAdmin;
  }

  async loadData() {
    const getCommandResponse: GetProjectsByUserCommandResponse = await this.pcs.apiService.GetProjectsByUser({});
    this.mapResponseToModel(getCommandResponse);
  }

  mapResponseToModel(getCommandResponse: GetProjectsByUserCommandResponse) {
    this.clientList = getCommandResponse.ClientList;
    this.cachedAssets = getCommandResponse.AssetList;
    this.cachedProjects = getCommandResponse.Projects;
    this.projects = this.cachedProjects.filter((item) => item.Active);
    this.userRoles = getCommandResponse.UserRoles;
    console.log("set projects in mapResponseToModel");
    this.clientCount = this.clientList.length;

    if (this.clientList.length === 1) {
      this.clientControl.setValue(this.clientList[0]);
      //Set State
      this.clientOptionsState.client = this.clientList[0];
      if (this.cachedAssets.length === 1) this.clientOptionsState.asset = this.cachedAssets[0];
    }
    this.loadState();
  }

  loadState() {
    //this.activeProjectsSelected = this.clientOptionsState.filterOption;
    //this.onProjectTypeChange(this.clientOptionsState.filterOption);
    if (this.clientOptionsState.client.ClientId > 0) {
      this.clientControl.setValue(this.clientOptionsState.client);
      this.filterClients(this.clientOptionsState.client.ClientId);
    }

    if (this.clientOptionsState.asset.AssetId > 0) {
      this.assetControl.setValue(this.clientOptionsState.asset);
      this.filterAssets(
        this.clientOptionsState.asset.AssetId,
        this.clientOptionsState.client.ClientId,
        this.setActive(this.clientOptionsState.filterOption)
      );
    } else {
      this.assetControl.setValue(0);
      if (this.clientOptionsState.client.ClientId) {
        this.filterAssets(0, this.clientOptionsState.client.ClientId, this.setActive(this.clientOptionsState.filterOption));
      }
    }

    if (this.clientOptionsState.filterOption !== "") {
      this.activeProjectsSelected = this.clientOptionsState.filterOption;
      this.onProjectTypeChange(this.clientOptionsState.filterOption);
    }

    if (this.clientOptionsState.projectSort !== "") {
      console.log(`Sort Project: ${this.clientOptionsState.projectSort}`);
      this.projectSortControl.setValue(this.clientOptionsState.projectSort);
      this.sortProjects(this.clientOptionsState.projectSort);
    }

  }

  newProject() {
    this.pcs.router.navigate(['new-project']);
  }

  clientSelected() {
    const clientId = this.clientControl.value.ClientId;
    this.projectSortControl.setValue("name-az");
    let client: ClientDto = this.clientControl.value;
    //Update state
    this.clientOptionsState.client = client;
    this.clientOptionsState.projectSort = "name-az";

    this.filterClients(clientId);
    this.sortProjects(this.clientOptionsState.projectSort);
  }

  filterClients(clientId: number) {
    //show selected client projects
    if (clientId > 0) {
      //Show projects with selected asset type
      if (this.setActive(this.activeProjectsSelected) !== null)
        this.projects =
          this.cachedProjects.filter((item) => item.Client.ClientId === clientId &&
            item.Active === this.setActive(this.activeProjectsSelected));
      else //Show all the project types for the selected client
        this.projects = this.cachedProjects.filter((item) => item.Client.ClientId === clientId);

      this.assetList = this.cachedAssets.filter((item) => item.Client.ClientId === clientId);
      if (this.assetList.length === 1) {
        this.assetControl.setValue(this.assetList[0]);
        this.clientOptionsState.asset = this.assetList[0];
      }
    }
    else {
      //Filter projects based on selected active selection
      if (this.setActive(this.activeProjectsSelected) === null)
        this.projects = this.cachedProjects;
      else //show all projects for all clients
        this.projects = this.cachedProjects.filter((item) => item.Active === this.setActive(this.activeProjectsSelected));

      this.assetList = [];
      this.projectSortControl.setValue("client-name-az");
    }
  }

  assetSelected() {
    const assetId = this.assetControl.value.AssetId;
    const clientId = this.clientControl.value.ClientId;
    const isActive = this.setActive(this.activeProjectsSelected);
    //Set State
    this.clientOptionsState.asset = this.assetControl.value;

    this.filterAssets(assetId, clientId, isActive);
  }

  filterAssets(assetId: number, clientId: number, isActive: boolean) {
    //Show selected asset
    if (assetId > 0) {
      //Assets get cleared when the client is changed so we have a client id
      //show all project types 
      if (isActive === null) {
        this.projects =
          this.cachedProjects.filter((item) => item.Client.ClientId === clientId &&
            item.Asset.AssetId === assetId);
      } else {
        this.projects =
          this.cachedProjects.filter((item) => item.Client.ClientId === clientId &&
            item.Asset.AssetId === assetId &&
            item.Active === isActive);
      }
    } else { //Show all assets
      //show all project types
      if (isActive === null) {
        this.projects =
          this.cachedProjects.filter((item) => item.Client.ClientId === clientId);
      } else {
        this.projects = this.cachedProjects.filter((item) =>
          item.Client.ClientId === clientId &&
          item.Active === isActive);
      }
    }

    this.sortProjects(this.projectSortControl.value);
  }

  projectSortChanged() {
    //Set State
    this.clientOptionsState.projectSort = this.projectSortControl.value;
    this.sortProjects(this.projectSortControl.value);
  }

  sortProjects(value: string) {
    console.log(`sorting projects method with ${value}`);
    console.log(`PRE sorted projects: first ${this.projects[0].Name} - last ${this.projects[this.projects.length - 1].Name}`);
    switch (value) {
      case "name-az":
        this.projects = this.projects.sort((a, b) => a.Name.localeCompare(b.Name));
        break;
      case "name-za":
        this.projects = this.projects.sort((a, b) => b.Name.localeCompare(a.Name));
        break;
      case "asset-name-az":
        this.projects = this.projects.sort((a, b) => a.Asset.Name.localeCompare(b.Asset.Name));
        break;
      case "asset-name-za":
        this.projects = this.projects.sort((a, b) => b.Asset.Name.localeCompare(a.Asset.Name));
        break;
      case "client-name-az":
        this.projects = this.projects.sort((a, b) => a.Client.Name.localeCompare(b.Client.Name));
        break;
      case "client-name-za":
        this.projects = this.projects.sort((a, b) => b.Client.Name.localeCompare(a.Client.Name));
        break;
      case "latest-desc":
        this.projects = this.projects.sort((a, b) => b.ProjectId - a.ProjectId);
        break;
      case "latest-asc":
        this.projects = this.projects.sort((a, b) => a.ProjectId - b.ProjectId);
        break;
    }
    console.log(`sorted projects: first ${this.projects[0].Name} - last ${this.projects[this.projects.length - 1].Name}`);
  }

  setActive(value: string): boolean {
    switch (value) {
      case "active":
        return true;
      case "inactive":
        return false;
      default:
        return null;
    }
  }

  //Change the projects shown based on their active status
  onProjectTypeChange(value: string) {
    //Set State
    this.clientOptionsState.filterOption = value;
    this.activeProjectsSelected = value;
    const isActive = this.setActive(value);

    const assetId = this.assetControl.value.AssetId;
    const clientId = this.clientControl.value.ClientId;
    //Show Active or Inactive projects
    if (this.activeProjectsSelected !== "all") {
      //Show projects for a selected client
      if (clientId > 0) {
        //show selected asset
        if (assetId > 0) {
          this.projects =
            this.cachedProjects.filter(
              (item) => item.Client.ClientId === clientId &&
                item.Asset.AssetId === assetId &&
                item.Active === isActive);
        }
        //show all assets for selected client
        else {
          this.projects =
            this.cachedProjects.filter(
              (item) => item.Client.ClientId === clientId &&
                item.Active === isActive);
        }
      }
      //Show all clients
      else {
        this.projects = this.cachedProjects.filter((item) => item.Active === isActive);
      }
    }
    //Show All projects
    else {
      //Show projects for a specific client
      if (clientId > 0) {
        //show projects for a specific asset
        if (assetId > 0) {
          this.projects =
            this.cachedProjects.filter((item) => item.Client.ClientId === clientId && item.Asset.AssetId === assetId);
        }
        //show all projects
        else {
          this.projects =
            this.cachedProjects.filter((item) => item.Client.ClientId === clientId);
        }
      }
      //Show all projects
      else {
        this.projects = this.cachedProjects;
      }
    }
  }

  compareClients(c1, c2) {
    return c1 && c2 ? c1.ClientId === c2.ClientId : c1 === c2;
  }

  compareAssets(a1, a2) {
    return a1 && a2 ? a1.AssetId === a2.AssetId : a1 === a2;
  }
}



// WEBPACK FOOTER //
// ./src/app/components/landing-page/landing-page.component.ts